export default __webpack_public_path__ + "static/media/sakura.cc95274a.png";